export function getEnvFromHTMLByName(name: string) {
  const element = document.querySelector(`meta[name="ENV_HYDRATE_${name}"]`)
  const content = element?.getAttribute('content') ?? null

  const isEmpty = content === null || content === `$__APP_${name}__`
  return isEmpty ? undefined : content.replace(/^"|"$/g, '')
}
